export default "__VITE_ASSET__c8196edb__"